import { useFloorPlanStore } from '../store/useFloorPlanStore'

/**
 * Action layer the UI components consume. Every action updates the local
 * (offline-first) store only, nothing is sent to the backend here.
 *
 * Persistence is explicit: the user saves the whole plan on demand via the Save
 * control (useFloorPlanSave). Editing therefore never hits the network, so
 * building a plan is instant and never triggers per-edit errors. The store stays
 * the single source the canvas renders from.
 *
 * This hook is kept as a stable indirection so components don't import the store
 * directly and so a different persistence strategy can be swapped in later
 * without touching every call site.
 */
export function useFloorPlanMutations() {
  const store = useFloorPlanStore()

  return {
    addRoom: store.addRoom,
    renameRoom: store.renameRoom,
    deleteRoom: store.deleteRoom,
    setActiveRoom: store.setActiveRoom,

    addTable: store.addTable,
    updateTablePosition: store.updateTablePosition,
    updateTablePositions: store.updateTablePositions,
    updateTableTransform: store.updateTableTransform,
    setTableSeatCount: store.setTableSeatCount,
    setTableShape: store.setTableShape,
    setTableLabel: store.setTableLabel,
    deleteTable: store.deleteTable
  }
}
